import React from 'react'
import styled from 'styled-components'
import { FiCalendar } from 'react-icons/fi'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 260px;
`
const Field = styled.input`
  width: 100%;
  padding: 8px 38px 8px 12px;    /* espaço para o ícone */
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 15px;
  line-height: 1.4;

  /* esconde o ícone nativo do navegador */
  &::-webkit-calendar-picker-indicator {
    opacity: 0;
    cursor: pointer;
  }
`
const Icon = styled(FiCalendar)`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
  width: 18px;
  height: 18px;
`

const toInputMonth = v => {
  const [mm, yyyy] = v.split('/')
  return yyyy && mm ? `${yyyy}-${mm.padStart(2,'0')}` : ''
}
const fromInputMonth = v => {
  const [yyyy, mm] = v.split('-')
  return mm && yyyy ? `${mm}/${yyyy}` : ''
}

export default function DateInput({
  value = '',
  dateFormat = 'dd/MM/yyyy',
  onChange
}) {
  let type        = 'date'
  let display     = value
  let placeholder = 'dd/mm/aaaa'
  let handler     = v => v

  if (dateFormat === 'MM/yyyy') {
    type        = 'month'
    display     = toInputMonth(value)
    placeholder = 'mm/aaaa'
    handler     = fromInputMonth
  } else if (dateFormat === 'yyyy') {
    type        = 'number'
    placeholder = 'aaaa'
    handler     = v => v.slice(0, 4)
  }

  return (
    <Wrapper>
      <Field
        type={type}
        value={display}
        placeholder={placeholder}
        onChange={e => onChange(handler(e.target.value))}
      />
      <Icon />
    </Wrapper>
  )
}
